import React from 'react';
import cx from 'classnames';
import { Image } from 'react-bootstrap';
import DefaultUserProfileImage from "src/legacy/images/default_user_profile_background.png";
import styles from './userListItemRow.module.scss';
import _ from 'lodash';
import { localizedStrings } from 'src/localization/index.jsx';
import Text from 'src/components/text';

class UserListItemRow extends React.Component {
  constructor(props) {
    super(props);

    this._handleDeleteClick = this._handleDeleteClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
  }

  renderName() {
    return `${this.props.user.firstName || ''} ${this.props.user.lastName || ''}`
  }

  renderInitials() {
    let initial = '';

    if (this.props.user.firstName) {
      initial = this.props.user.firstName.charAt(0);
    }

    if (this.props.user.lastName) {
      initial = initial + this.props.user.lastName.charAt(0);
    }

    return initial.toUpperCase();
  }

  _handleDeleteClick() {
    this.props.onRemove(this.props.user);
  }

  render() {
    if (!this.props.user) {
      return null;
    }
    return (
      <div className={styles.userContainer}>
        <div className={styles.contentContainer}>
          <div className={styles.userAvatar}>
            {_.get(this.props, 'user.icon.thumbnail') == null &&
              <Image className={styles.contactAvatar} src={DefaultUserProfileImage} circle />
            }
            {_.get(this.props, 'user.icon.thumbnail') != null &&
              <Image className={styles.contactAvatar} src={this.props.user.icon.thumbnail} circle />
            }
          </div>
          <div className={styles.userDetails}>
            <div className={styles.contactName}>
              <Text className={styles.userName} text={this.renderName()} lines={1} />
            </div>
            <div className={styles.contactEmail}>
              <Text lines={1} className={styles.userEmail} text={this.props.user.email || this.localizedCommons.no_details}  />
            </div>
          </div>
        </div>
        <span onClick={this._handleDeleteClick} className={cx(styles.closeButton)}>
          <i className='paperflite-close' />
        </span>
      </div>
    );
  }
}

UserListItemRow.defaiultProps = {

}

export default UserListItemRow;